module.exports = function() {
    var CampaignActionCenter = {
        $hiddeninputs: [],
        fieldOptions: {}
    };

    CampaignActionCenter.init = function () {
        
    };

    CampaignActionCenter.openwindow = null;
    CampaignActionCenter.actions = {
        actionscompleted: new Array()
    };

    CampaignActionCenter.ShowStepOne = function (type) {
        var $steponecontainer = $('#steponecontainer');
        if ($steponecontainer && $steponecontainer.length) {
            //$('.' + type + '-preview', $steponecontainer).show();
            var $steptwocontainer = $('#steptwocontainer');

            $steponecontainer.slideDown(300);
            $steptwocontainer.slideUp(300, function () {
                $('.previewcontainer', $steptwocontainer).hide();
                $('.close-dialog', $steptwocontainer).hide();
                // broadcast an event
                $(document).trigger('widgetFormEvent', {event: 'cacShowStepOne'});
            });
        }
    };
    CampaignActionCenter.ShowStepTwo = function (type) {
        var $steptwocontainer = $('#steptwocontainer');
        if ($steptwocontainer && $steptwocontainer.length) {
            $('.close-dialog', $steptwocontainer).show();
            $('.previewcontainer', $steptwocontainer).not('.' + type + '-preview').hide();
            $('.' + type + '-preview', $steptwocontainer).show();
            $('#steponecontainer').slideUp(300);
            $steptwocontainer.slideDown(300, function () {
                // broadcast an event
                $(document).trigger('widgetFormEvent', {event: 'cacShowStepTwo'});
            });
            $('html, body').animate({
                scrollTop: $('#actioncenterform').offset().top
            }, 300);
        }
    };

    CampaignActionCenter.ShowHiddenInputs = function () {
        $.each(CampaignActionCenter.$hiddeninputs, function () {
            var $me = $(this);
            $me.show();
            //Make sure we removed it from completed checkboxes if its in there
            var completedcheckboxlength = window.checkboxescompleted.length;
            for (var i = 0; i < completedcheckboxlength; i++) {
                if ($me.find('input').attr('name') == window.checkboxescompleted[i]) {
                    window.checkboxescompleted[i] = null;
                    delete window.checkboxescompleted[i]; //delete won't always work for all variables
                    break;
                }
            }
        });
    };

    CampaignActionCenter.call = {
        callbuttonstartingtext: null,
        $previewcontainer: null,
        returndata: null
    };
    CampaignActionCenter.call.UpdateStatus = function (uniqueid, status) {
        var $legscalledcontainer = $('.legislators-called', CampaignActionCenter.call.$previewcontainer);
        var $legcontainer = $('[data-uniqueid="' + uniqueid + '"]', $legscalledcontainer);

        //Hide all caller-tips (only one leg can be in progress at once)
        $('.caller-tip', $legscalledcontainer).not('[data-uniqueid="' + uniqueid + '"]').remove();
        //Change the container for this leg to the status
        $legcontainer.attr('data-status', status);
        //Hide all the other status elements
        $('[data-status]:not([data-status="' + status + '"])', $legcontainer).hide();
        //Show all the status elements for this status
        $('[data-status="' + status + '"]', $legcontainer).show();

        if (status == 'IN-PROGRESS') {
            $legcontainer.after('<li class="list-group-item caller-tip" data-status="IN-PROGRESS" data-uniqueid="' + uniqueid + '">Dial <i class="fa fa-asterisk"></i> to advance to the next official!</div>');
        } else if (status == 'COMPLETED') {
            var $mediabody = $('.media-body', $legcontainer);
            $mediabody.find('.leg-photo').remove();
            $mediabody.prepend('<i class="fa fa-check fa-2x leg-photo leg-call-icon-completed"></i>');
            $('.leg-name', $mediabody).css('color', '#FFF');

            //See if there any non-completed legs
            //If not, mark this step as completed
            $('.caller-tip').remove();
        }
        CampaignActionCenter.ShowStepTwo('call');
    };

    CampaignActionCenter.FormatPhone = function (phone) {
        //Format the phone
        var displayphone = phone.substr(0, 3).toString();
        if (phone.substr(3, 3)) {
            displayphone += '-' + phone.substr(3, 3);
        }
        if (phone.substr(6, 4)) {
            displayphone += '-' + phone.substr(6, 4);
        }
        return displayphone;
    };

    CampaignActionCenter.emailpreviewed = false;
    CampaignActionCenter.email = {
        twostep: false,
        $previewcontainer: null,
        originalbutton: '',
        actioncompleted: false
    };

    CampaignActionCenter.twitter = {
        shownlegs: false,
        sharebody: false,
        previewcontainer: null,
        originalbutton: null
    };

    CampaignActionCenter.facebook = {
        shownlegs: false,
        numofmentions: 0,
        unselectedlegs: false,
        typedtext: false,
        messages: {},
        postspusher: null,
        $previewcontainer: null
    };

    CampaignActionCenter.OpenWindow = function (url) {
        if (typeof url === 'undefined') {
            var url = '';
        }

        //If http and https are missing, add the appropriate one
        if (url.length && url.indexOf('http://') === -1 && url.indexOf('https://') === -1) {
            if (window.location.protocol === 'https:') {
                url = 'https://' + url;
            } else {
                url = 'http://' + url;
            }
        }

        if (CampaignActionCenter.openwindow !== null) {
            CampaignActionCenter.openwindow.location.href = url;
        } else {
            CampaignActionCenter.openwindow = window.open(url);
        }
    };
    CampaignActionCenter.CloseWindow = function () {
        if (CampaignActionCenter.openwindow !== null) {
            CampaignActionCenter.openwindow.close();
            CampaignActionCenter.openwindow = null;
        }
    };

    CampaignActionCenter.showCustomFields = () => {

        const $customFieldsContainer = $('#customfieldscontainer');
        const $customFieldsContainerFormGroup = $('.form-group', $customFieldsContainer);

        $customFieldsContainer.show();
        $customFieldsContainerFormGroup.show();
        $('input, label', $customFieldsContainerFormGroup).show();
    }

    CampaignActionCenter.isPreviewVisible = () => {
        const previewButtons = [
            CampaignActionCenter.twitter.$previewcontainer,
            CampaignActionCenter.facebook.$previewcontainer,
            CampaignActionCenter.twitter.$previewcontainer,
            CampaignActionCenter.call.$previewcontainer,
            CampaignActionCenter.email.$previewcontainer
        ];

        let isPreviewVisible = false;

        previewButtons.forEach(preview => {
            if (preview && preview.is(':visible')) {
                isPreviewVisible = true;
            }
        });

        return isPreviewVisible;

    }

    CampaignActionCenter.isSubmitButtonVisible = () => {

        const submitButtons = ['#emailsubmitbutton', '#facebooksubmitbutton','#twittersubmitbutton','#callsubmitbutton'];
        let isSubmitButtonVisible = false;

        submitButtons.forEach(button => {
            if($(button).is(':visible')){
                isSubmitButtonVisible = true;
            }
        })

        return isSubmitButtonVisible;
    }

    CampaignActionCenter.handleHideCustomFieldsMutations = (mutationRecord) => {

        if(CampaignActionCenter.handledCustomFieldsPriorityDisplay()){
            return true;
        }

        const $customFieldsContainer = $('#customfieldscontainer');

        if(mutationRecord.target.id
            && $(mutationRecord.target).is(':visible')){
            $customFieldsContainer.hide();
            return true;
        }

        if(!$('#cookie-badge').length){
            $customFieldsContainer.hide();
            return true;
        }

        if(window.numactionscompleted > 0){
            $customFieldsContainer.hide();
        }
    }

    /**
     * These conditions trump any other for showing/hiding custom fields
     *
     * @return true - if any of the conditions laid out in the function was met, false otherwise
     */
    CampaignActionCenter.handledCustomFieldsPriorityDisplay = () => {

        const $customFieldsContainer = $('#customfieldscontainer');

        if(!$customFieldsContainer.length){
            return true;
        }


        if($('#submitloadingcontainer').is(':visible')){
            $customFieldsContainer.hide();
            return true;
        }

        if($('#cookie-badge').is(':visible')){
            CampaignActionCenter.showCustomFields();
            return true;
        }

        const isPreviewVisible = CampaignActionCenter.isPreviewVisible();
        const isSubmitButtonVisible = CampaignActionCenter.isSubmitButtonVisible();

        if(isPreviewVisible && window.numactionscompleted > 0) {
            $customFieldsContainer.hide();
            return true;
        }

        if(isSubmitButtonVisible){
            CampaignActionCenter.showCustomFields();
            return true;
        }

        if($(".advocate-action-error").length
            && $(".advocate-action-error").is(':visible')){
            CampaignActionCenter.showCustomFields();
            return true;
        }

        return false;
    }

    /**
     * Listen to completed events of various action to decide
     * whether to show/hide the custom fields
     */
    CampaignActionCenter.handleActionCompletedFields = () => {

        $(document).on("action", function(event) {

            if (event.handled === true || !event.hasOwnProperty("message")){
                return true;
            }

            if (!window.advocateid){
                return true;
            }

            if(["email","facebook", "twitter", "call"].indexOf(event.message) === -1){
                return true;
            }

            if(CampaignActionCenter.handledCustomFieldsPriorityDisplay()){
                return true;
            }

            // if the action has just been completed, force hide the custom fields, cookie enabled or
            $('#customfieldscontainer').hide();
            event.handled = true
        });
    }

    CampaignActionCenter.handleHideCustomFields = () => {

        // Add listeners for when the action is completed
        CampaignActionCenter.handleActionCompletedFields();

        // @see https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
        // Hide Custom fields if any of the target elements is present in the dom
        // And show them if either we have an advocate error message, or the cookie badge
        const hideCustomFieldsObserver = new MutationObserver(function(mutations) {
            mutations.forEach((mutationRecord) =>  CampaignActionCenter.handleHideCustomFieldsMutations(mutationRecord));
        });

        // Hide custom fields when these elements are in the DOM
        const hideCustomFieldsHideTargets = [
            document.getElementById('submitloadingcontainer'),
            document.getElementById('facebookpreviewcontainer'),
            document.getElementById('twitterpreviewcontainer'),
            document.getElementById('emailpreviewcontainer'),
            document.getElementById('actionexplanation'),
            document.getElementById('cookie-badge'),
            document.getElementById('emailsubmitbutton'),
            document.getElementById('facebooksubmitbutton'),
            document.getElementById('twittersubmitbutton'),
            document.getElementById('callsubmitbutton'),
        ];

        hideCustomFieldsHideTargets.forEach(target => {
            if(target){
              hideCustomFieldsObserver.observe(target, { attributes : true, attributeFilter : ['style'] });
            }

        });

        // Make sure we handle conditions that take precedence over any other for showing/hiding custom fields
        if(CampaignActionCenter.handledCustomFieldsPriorityDisplay()){
            return true;
        }
    }

    CampaignActionCenter.ShowActionFields = function(parentid, aftererror) {
        if (typeof aftererror === 'undefined') {
            aftererror = false;
        }

        var speed = window.actiontransitionspeed,
            show = false,
            action = null,
            fieldName = null,
            fieldOption = null,
            fieldNameDB = null,
            valRequired = false;

        CampaignActionCenter.handleHideCustomFields();

        $('#action-form :input, #action-form :checkbox, #action-form :radio, #take-action-form :input, #take-action-form :checkbox, #take-action-form :radio').each(function() {

            fieldName = null;
            fieldNameDB = null;

            show = false;
            var $me = $(this);

            //Don't remove the buttons, or touch specific elements
            if ($me.prop('tagName') == 'BUTTON' || $me.parent().hasClass('email-message')) {
                return true;
            }

            if (parentid == 'action-twitter') {
                action = 'Twitter';
            } else if (parentid == 'action-facebook') {
                action = 'Facebook';
            } else if (parentid == 'action-call') {
                action = 'Phone';
            } else if (parentid == 'action-email') {
                action = 'Email';
            } else if (parentid === 'petition') {
                action = '';
            }

            fieldName = CampaignActionCenter.interpretFieldName($me);
            if (fieldName == 'fullname') {
                fieldName = 'name';
            }
            if (fieldName) {
                fieldNameDB = CampaignActionCenter.calculateFieldNameDB(fieldName);
            }
            
            if (fieldNameDB) {
                if (parentid === 'petition') {
                    fieldOption = CampaignActionCenter.fieldOptions.standard['fields' + fieldNameDB + action];
                } else {
                    fieldOption = CampaignActionCenter.fieldOptions['fields' + fieldNameDB + action];
                }

                if (fieldOption === 1 || fieldOption === 2) {
                    show = true;
                    if (fieldOption === 1) {
                        valRequired = true;
                    } else {
                        valRequired = false;
                    }
                } else {
                    show = false;
                    valRequired = false;
                }
            }

            // Show Custom fields
            if ($me.attr('name').indexOf('fields[') !== -1) {

              if(!$('#customfieldscontainer').is(':visible')){
                CampaignActionCenter.showCustomFields();
              }
              return true;
            }

            //Don't ask for info we already have from a previous action
            //If this is after an error, we want to actually show the info
            if ((show === true) && window.numactionscompleted > 0 && aftererror === false) {
                if ($me.is(':checkbox')) {
                    //Loop over our completed checkboxes; if the user already checked this box and submitted it with a different action, don't show it again
                    for (var i = 0, n = window.checkboxescompleted.length; i < n; i++) {
                        if (window.checkboxescompleted[i] == $(this).attr('name')) {
                            var show = false;
                            //We actually want to disable it so it doesn't get passed with future actions
                            //$(this).prop('disabled', true);

                            break;
                        }
                    }
                } else if ($me.val().length > 0) {
                    //Always show phone number for call
                    if (action != 'Phone' || fieldName != 'phone') {
                        show = false;
                    }
                }
            }

            var inputPlaceholder = $me.attr('placeholder');
            if (inputPlaceholder) {
                var lastChar = inputPlaceholder.substr(-1);
            }
            if (valRequired === true) {
                $me.attr('aria-required', true);
                $me.prop('required', true);
                //only add required icon when one does not already exist
                if ($me.parent().find('.input-required-icon').length <= 0) {
                    var name = $me.attr('name');
                    if (name == "phone") {
                        var parentWidth = $me.parent().parent().width();;
                        var right = parentWidth - $me.width() - 30;
                        $("<span class='input-required-icon' style='right:" + right + "px'><i class='fa fa-asterisk'></i></span>").insertAfter($me);
                    } else if (name == "zip5") {
                        var parentWidth = $me.parent().parent().width();;
                        var right = parentWidth - $me.width() - 30;
                        $("<span class='input-required-icon input-required-icon-zip' style='right:" + right + "px'><i class='fa fa-asterisk'></i></span>").insertAfter($me);
                    } else {
                        $("<span class='input-required-icon'><i class='fa fa-asterisk'></i></span>").insertAfter($me);
                    }
                }
            } else {
                $me.attr('aria-required', false);
                $me.prop('required', false);
                $me.parent().find('.input-required-icon').remove();
            }

            if (show === true) {
                if (fieldName == 'name' || fieldName == 'prefix') {
                    $me.parent().parent().show(speed);
                } else {
                    //If showing prefix, make sure name is appropriate width and has padding
                    if (fieldName == 'title') {
                        $('#fullname').parent().attr({
                            class: 'col-sm-8 col-xs-8',
                            style: 'padding-left:5px;'
                        });
                    }
                    $me.parent().show(speed);
                }

                if (fieldName == 'phone') {
                    $('.phone-info-icon').show();
                }

                return true;
            } else {
                if (fieldName == 'name' || fieldName == 'prefix') {
                    $me.parent().parent().hide(speed);
                } else {
                    // If hiding prefix, make name field full width
                    if (fieldName == 'title') {
                        $me.parent().hide(speed, function() {
                            $("#fullname").parent().attr({
                                class : 'col-md-12',
                                style : ''
                            });
                        });
                    } else {
                        if (parentid !== 'petition') {
                            $me.parent().hide(speed);
                        }         
                    }
                }
                if (fieldName == 'phone') {
                    $('.phone-info-icon').hide();
                }
            }
        });

        //Trigger click when user tabs over link and clicks space
        //Allows users using screen readers to change contact method without having to find element with mouse
        $('.action-image').keypress(function(e) {
            if (e.which == 32) {
                $(this).click();
            }
        });

        //Facebook specific language
        if (action == 'Facebook' && CampaignActionCenter.facebook.shownlegs === true) {
            $('.facebook-permissions-warning').show();
        } else {
            $('.facebook-permissions-warning').hide();
        }

        // broadcast an event
        $(document).trigger('widgetFormEvent', {event: 'cacShowActionFields'});
    };

    CampaignActionCenter.interpretFieldName = function($field) {
        return $field.attr('data-fieldname');

    };
    CampaignActionCenter.calculateFieldNameDB = function(fieldName) {
        if (fieldName) {
            return fieldName.substr(0, 1).toUpperCase() + fieldName.substr(1);
        }
    };

    return CampaignActionCenter;
};
